import React from "react";
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { Info } from "lucide-react";

export function Section({ value, icon: Icon, title, children, testid, hint }) {
  return (
    <AccordionItem value={value} className="border-b border-[color:var(--glass-border)]">
      <AccordionTrigger data-testid={testid} className="py-2.5 text-xs font-semibold text-[color:var(--ink)] hover:no-underline [&>svg]:shrink-0">
        <span className="flex items-center gap-1.5 min-w-0">
          <Icon className="w-3.5 h-3.5 shrink-0 text-[color:var(--brand-ocean)]" />
          <span className="truncate">{title}</span>
          {hint && (
            <span title={hint} onClick={(e) => e.stopPropagation()} className="shrink-0 cursor-help text-[color:var(--ink-3)] hover:text-[color:var(--brand-ocean)]" data-testid={testid ? `${testid}-info` : undefined}>
              <Info className="w-3 h-3" />
            </span>
          )}
        </span>
      </AccordionTrigger>
      <AccordionContent className="pb-4 space-y-4">{children}</AccordionContent>
    </AccordionItem>
  );
}

export function StyleToggle({ label, checked, onChange, testid }) {
  return (
    <div className="flex items-center justify-between gap-2 py-1">
      <Label className="text-sm text-[color:var(--ink-2)]">{label}</Label>
      <Switch data-testid={testid} checked={checked} onCheckedChange={onChange} className="shrink-0" />
    </div>
  );
}

// Item 61 — per-measure Quick Calc / "Show Value As"
